import { FC } from 'react'
import { BitazzaText } from '../../../../components'
import { getColor } from '../../../../util/getColor'
import { getComparedTextOverall } from '../../../../util/getComparedText'

import Style from './OverallPnlBox.module.scss'
import { useTranslation } from 'react-i18next'
interface Props {
    pnl: number
    total?: number
    userRank?: number | null
}
export const OverallPnlBox: FC<Props> = ({ pnl, userRank, total }) => {
    const { t } = useTranslation()
    const getPnl = () => {
        switch (true) {
            case pnl > 0:
                return `+${pnl.toFixed(2)}%`
            case pnl < 0:
                return `${pnl}%`
            default:
                return `0.00%`
        }
    }

    return (
        <div className={Style.container}>
            <BitazzaText
                content={t('txt_overall_pnl')}
                format="t20"
                letterSpacing={2}
                color="#FFF"
                display="block"
                semiBold
            />
            <BitazzaText
                content={getPnl()}
                format="t32"
                bold
                letterSpacing={2}
                color={getColor(pnl)}
                lineHeight={42}
            />

            {!userRank ? (
                <BitazzaText
                    content={'You’re unranked. Try again next season!'}
                    format="t16"
                    color="#86A1A1"
                    lineHeight={16}
                    display="inline"
                />
            ) : null}

            <BitazzaText
                content={getComparedTextOverall(userRank, total)}
                format="t16"
                color="#86A1A1"
                lineHeight={16}
                display="inline"
            />
        </div>
    )
}
